import React, { Fragment } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { IconButton } from "@mui/material";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";
import StyledCheckBox from "./elements/StyledCheckBox";
import File from "./elements/File";

import {
  Data,
  HeaderCellStyle,
  StyledTableContainer,
  StyledTableHead,
  StyledTableWrapper,
} from "./styled/StyledTable.styled";

function ModalMatrixTableHead(props) {
  const { headCells, order, setOrder } = props;
  const handleChangeSort = (id) => {
    setOrder({ id: id, sort: order.sort === "asc" ? "dsc" : "asc" });
  };
  const handleChangeId = (id) => {
    setOrder({ id: id, sort: "asc" });
  };

  return (
    <StyledTableHead>
      <TableRow>
        <TableCell align="center" colSpan={2}></TableCell>
        <TableCell align="center" colSpan={10}>
          Countries
        </TableCell>
      </TableRow>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            align={"left"}
            sx={{ width: "fit-content", padding: "10px" }}
            style={{ top: 57 }}
          >
            <HeaderCellStyle key={`cell${index}`}>
              {headCell.label}
              {headCell.sorting && (
                <Fragment>
                  {order.id === headCell.id ? (
                    <IconButton
                      onClick={() => {
                        handleChangeSort(headCell.id);
                      }}
                    >
                      {order.sort === "asc" && (
                        <BiUpArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                      {order.sort === "dsc" && (
                        <BiDownArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        handleChangeId(headCell.id);
                      }}
                    >
                      <BiUpArrowAlt
                        style={{
                          fontSize: "14px",
                          opacity: "0.5",
                        }}
                      />
                    </IconButton>
                  )}
                </Fragment>
              )}
            </HeaderCellStyle>
          </TableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
}

export default function ModalMatrixTable({
  headCells,
  rows,
  order,
  setOrder,
  clickSwitch,
  countryCheck,
  checkbox,
  ...props
}) {
  return (
    <StyledTableWrapper mt={"0px"}>
      <StyledTableContainer>
        <Table
          sx={{ minWidth: "100px", padding: "0px 10px" }}
          aria-label="sticky table"
          stickyHeader={true}
        >
          <ModalMatrixTableHead
            headCells={headCells}
            order={order}
            setOrder={setOrder}
          />
          <TableBody>
            {rows.map((row, index) => {
              const labelId = `enhanced-table-row-${index}`;
              return (
                <TableRow key={labelId} hover>
                  {Object.keys(row).map((key) => {
                    if (key === "id") {
                      return null;
                    } else if (key === "model") {
                      return (
                        <TableCell align={"center"} sx={{
                                    maxWidth: "200px",
                                    minWidth: "100px",
                                    overflowWrap: "break-word",
                                  }}>
                          <Data>{row[key]}</Data>
                        </TableCell>
                      );
                    } else if (key === "file") {
                      return (
                        <TableCell
                          align={"left"}
                          sx={{
                            maxWidth: "200px",
                            minWidth: "80px",
                            overflowWrap: "break-word",
                          }}
                        >
                          <File fileName={"template.xlxs"} />
                        </TableCell>
                      );
                    } else
                      return (
                        <TableCell align={"center"}>
                          <StyledCheckBox
                            id={row.id}
                            checked={row[key].length > 0 ? true : false}
                            onChange={() => {
                              countryCheck({
                                data: row,
                                column: key,
                                isChecked: row[key],
                              });
                            }}
                          />
                        </TableCell>
                      );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </StyledTableWrapper>
  );
}
